<label class="horizontal control-label">{{ to.label }}</label>
<editor [formControl]="formControl" [formlyAttributes]="field" [init]="config"
    [initialValue]="formControl.value || (to.initialValue ? to.initialValue : '')" class="mb-3">
</editor>
